module.exports = __webpack_public_path__ + "static/media/align-center.24c86d32.svg";